import { instanceV2 } from "../../api";

const wabaChatsApi = {
    getConversations: (branchId, page, search) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (search) params.append('search', search);
        return instanceV2().get(`/branches/${branchId}/waba/conversations?${params.toString()}`).then(res => res.data);
    },
    getMessages: (branchId, conversationId, before, after, limit) => {
        const params = new URLSearchParams();
        if (before) params.append('before', before);
        if (after) params.append('after', after);
        if (limit) params.append('limit', limit);
        return instanceV2().get(`/branches/${branchId}/waba/conversations/${conversationId}/messages?${params.toString()}`).then(res => res.data);
    },
    sendTextMessage: (branchId, conversationId, text) => {
        return instanceV2().post(`/branches/${branchId}/waba/conversations/${conversationId}/messages/text`, { text }).then(res => res.data);
    },
    sendMediaMessage: (branchId, conversationId, data) => {
        return instanceV2().post(`/branches/${branchId}/waba/conversations/${conversationId}/messages/media`, data).then(res => res.data);
    },
    uploadFile: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return instanceV2().post('/upload-file', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => res.data);
    },
    markRead: (branchId, conversationId) => {
        return instanceV2().patch(`/branches/${branchId}/waba/conversations/${conversationId}/read`).then(res => res.data);
    },
    dismissMessage: (branchId, conversationId, messageId) => {
        return instanceV2().patch(`/branches/${branchId}/waba/conversations/${conversationId}/messages/${messageId}/dismiss`).then(res => res.data);
    },
}
export default wabaChatsApi
